import {CONSONANT_VOWEL_PAIRS_S_T} from "../../../SubjectData/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_st.js";
import "../../Deck.css";
import FlashcardInterface from "../../Flashcard_Interface.js";
import HeaderNav from "../../../Components/Header/Header_Nav/Header_Nav.js";


export default function CONSONANT_VOWEL_PAIRS_S_T_DECK() {


 return(
 
     <>
        <HeaderNav GoBack_to={"/ConsonantVowelPairsNav"}/>
        <FlashcardInterface deckData={CONSONANT_VOWEL_PAIRS_S_T} title="Consonant-Vowel Pairs: ㅅ (s/t)" />
     </>
);}